import React from 'react'
import AuthorizedRoutes from '@routes/AuthorizedRoutes'
import UnauthorizedRoutes from '@routes/UnauthorizedRoutes'

const useRoutes = (authorized) => {
    return authorized ? <AuthorizedRoutes/> : <UnauthorizedRoutes/>
}

export default useRoutes